<div class="table-container">
  <table mat-table [dataSource]="dialogs" matSort>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "admin.dialogs.id" | translate }} </th>
      <td mat-cell *matCellDef="let dialog">{{dialog.id}}</td>
    </ng-container>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "admin.dialogs.code" | translate }} </th>
      <td mat-cell *matCellDef="let dialog">{{dialog.code}}</td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "admin.dialogs.title" | translate }} </th>
      <td mat-cell *matCellDef="let dialog">{{dialog.comment}}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let dialog">
          <mat-icon (click)="editDialog(dialog)"  color="primary">edit</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
